import { observer } from "mobx-react";
import { Toast } from "primereact/toast";
import React, { ReactNode } from "react";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { withWSErrorContainer } from "../../error/withWSErrorContainer";

const life = 3000;

const ChangesSuccessToast = observer(() => {
  const L = useLocStore(LocContext.GENERAL);

  return <>{L.id("d0ff9e20d8b2").loc("Endringene er lagret")}</>;
});

export const showChangesSuccessToastMsg = () => {
  toastRef!.show({
    severity: "success",
    detail: <ChangesSuccessToast />,
    life,
  });
};

export const showSuccessToastMsg = (detail: string) => {
  toastRef!.show({
    severity: "success",
    detail,
    life,
  });
};

export const showErrorToastMsg = (err, summary?: ReactNode) => {
  const text = err?.response?.data ?? err?.message ?? err;

  toastRef!.show({
    severity: "error",
    summary,
    detail: text,
    life,
  });
};

// storing ref globally is generally a bad idea,
// but in this particular usecase it made things easier
let toastRef: Toast | null = null;

export const CvpToast = withWSErrorContainer(() => {
  return (
    <Toast
      ref={(ref) => {
        toastRef = ref;
      }}
    />
  );
});
